// AI 판독 고지 — 문구의 **단일 원천**.
//
// 같은 사실을 두 자리에서 말한다(셸 제목 아래 · 대표 콘텐츠 블록). 각자 따로 쓰면 한쪽만 고쳐져
// 화면이 서로 다른 범위를 주장하게 되므로 컴포넌트로 묶는다.
//
// 대상을 명시하는 이유는 **숫자까지 싸잡지 않기 위해서**다 — 조회수·좋아요·구독자는 플랫폼
// 원본이고 AI 와 무관하다. YouTube 는 사람이 확정하므로 문구에서 분리한다.
import { Info } from 'lucide-react'

export function AiJudgedNotice({ className }: { className?: string }) {
  return (
    <div
      className={[
        'flex items-start gap-1.5 break-keep font-text text-[12px] leading-[1.5] text-fg-3',
        className ?? '',
      ].join(' ')}
    >
      <Info className="mt-[3px] h-3 w-3 flex-none text-brand-blue" aria-hidden />
      <span>
        <span className="font-medium text-fg-2">Instagram · TikTok</span>의 브랜디드 여부 ·
        브랜드명 · 상품명은{' '}
        <span className="font-medium text-fg-2">AI가 캡션을 판독한 결과</span>입니다.
      </span>
    </div>
  )
}
